import axios from "axios"
import { DateTime } from "luxon"

export const deploymentDate = (): Promise<DateTime | undefined> => {
  if (window.location.hostname === "localhost") {
    return Promise.resolve(undefined)
  }

  return axios
    .create({
      timeout: 10000,
    })
    .get(`${window.location.origin}/deployment.txt`)
    .then((resp) => {
      const bodyValue = `${resp.data}`.trim()
      const dateTimeObject = DateTime.fromISO(bodyValue)

      return dateTimeObject.isValid ? dateTimeObject : undefined
    })
    .catch((e) => {
      console.error("Error getting deployment file", e)
      return undefined
    })
}
